import { io } from 'socket.io-client';

const URL = process.env.NODE_ENV === 'production' ? '/players' : 'http://localhost:3000/players';

export const socket = io(URL, {
  autoConnect: false
});